import http from './http'

export default {
  user: {
    get (id) {
      return http.get('/user/get', {id: id})
    },
    getList (searchItem, pageConfig) {
      return http.get('/user/getlist', {
        shopId: searchItem.shop,
        roleId: searchItem.roleId,
        keyword: searchItem.keyword,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize,
        status: searchItem.status
      })
    },
    getFullList (shopId) {
      return http.get('/user/getfulllist', {shopId: shopId})
    },
    create (model) {
      return http.post('/user/create', model)
    },
    update (model) {
      return http.post('/user/update', model)
    },
    delete (id) {
      return http.post('/user/delete', id)
    },
    updatePassword (model) {
      return http.post('/user/updatepassword', model)
    }
  },
  role: {
    getList () {
      return http.get('/user/role/getlist')
    },
    get (id) {
      return http.get('/user/role/get', {id: id})
    },
    create (model) {
      return http.post('/user/role/create', model)
    },
    update (model) {
      return http.post('/user/role/update', model)
    },
    delete (id) {
      return http.post('/user/role/delete', id)
    },
    getMenuIdsByRoleId (id) {
      return http.get('/user/role/getpermissionsbyroleid', {id: id})
    },
    updateRoleMenus (model) {
      return http.post('/user/role/updaterolemenus', model)
    }
  },
  userTag: {
    getList () {
      return http.get('/user/usertag/getlist')
    },
    get (id) {
      return http.get('/user/usertag/get', {id: id})
    },
    create (model) {
      return http.post('/user/usertag/create', model)
    },
    update (model) {
      return http.post('/user/usertag/update', model)
    },
    delete (id) {
      return http.post('/user/usertag/delete', id)
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/user.js